import type { NuxtLinkProps } from '#app'

/**
 * Resolves links in article CTAs to the current product slugs.
 *
 * A bit nasty, since we have hardcoded checks by product name, but it's the best we can do without changing the Crystallize shapes.
 */
export function useCtaLinks() {
  const { data } = useProducts('/aunivers')

  type LinkConfig = Record<CtaLink, {
    to: NuxtLinkProps['to']
    label: string
  }>

  return computed<LinkConfig>(() => {
    const results = {
      'aunivers-barneskole': {
        to: {
          name: 'product',
          params: { slug: 'aunivers-barneskole' },
        },
        label: 'Les mer om Aschehoug Univers for barneskole',
      },
      'aunivers-ungdomsskole': {
        to: {
          name: 'product',
          params: { slug: 'aunivers-ungdomsskole' },
        },
        label: 'Les mer om Aschehoug Univers for ungdomsskole',
      },
      'digitalt-supplement': {
        to: {
          name: 'product',
          params: { slug: 'aunivers-vgs' },
        },
        label: 'Les mer om Digitalt supplement for VGS',
      },
      'produktkatalog': {
        to: { name: 'products' },
        label: 'Se produktkatalogen',
      },
    } satisfies LinkConfig

    const products = data.value?.products ?? []
    for (const product of products) {
      if (!isPacket(product))
        continue

      if (product.name?.toLowerCase().includes('vgs')) {
        results['digitalt-supplement'].to.params.slug = product.slug.short
      } else if (product.name?.toLowerCase().includes('univers')) {
        if (product.levels?.includes('1-7')) {
          results['aunivers-barneskole'].to.params.slug = product.slug.short
        } else if (product.levels?.includes('8-10')) {
          results['aunivers-ungdomsskole'].to.params.slug = product.slug.short
        }
      }
    }

    return results
  })
}
